import { c as _c } from "react/compiler-runtime";
import ErrorPage from '@/components/modules/ErrorBoundary/ErrorPage';
import { captureException } from '@sentry/react';
import { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';
const RouterErrorPage = () => {
    const $ = _c(5);
    const error = useRouteError();
    let t0;
    let t1;
    if ($[0] !== error) {
        t0 = () => {
            captureException(error, { level: "fatal" });
        };
        t1 = [error];
        $[0] = error;
        $[1] = t0;
        $[2] = t1;
    }
    else {
        t0 = $[1];
        t1 = $[2];
    }
    useEffect(t0, t1);
    let t2;
    if ($[3] !== error) {
        t2 = <ErrorPage error={error}/>;
        $[3] = error;
        $[4] = t2;
    }
    else {
        t2 = $[4];
    }
    return t2;
};
export default RouterErrorPage;
